module.exports = __webpack_public_path__ + "img/house-restoration.c0d8c687.png";